export default "__VITE_ASSET__f5hIY94$__"